import { SUCCESS, type SocialAPI } from ".";
import HTTPStatus from "@/realize-shared/HTTPStatus";

export default class AssetsAPI
{
    public constructor(private api: SocialAPI)
    {
    }

    public async getLegalText(): Promise<{
        status: HTTPStatus;
        message: string;
        data?: {
            terms: string;
            privacy: string;
        }
    }>
    {
        const res = await this.api.fetch<{ terms: string, privacy: string }>("/legal");

        if (res.status !== SUCCESS)
        {
            Logger.log("Legal Response", res.data);

            return {
                status: res.status,
                message: res.message,
            };
        }

        return {
            status: 200,
            message: "Assets retrieved successfully.",
            data: res.data,
        };
    }
}
